import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.checklist');
import { Input, Output, EventEmitter, ChangeDetectorRef, NgZone } from "@angular/core";

@Component({
    selector: 'wiz-component-checklist',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.checklist/view.scss */
/* src/app/component.checklist/view.scss: no such file or directory */`],
})
export class ComponentChecklistComponent {
  @Input() items: any[] = [];
  @Output() qaSelected = new EventEmitter<any>();
  public openedIndex: number | null = null;

  constructor(@Inject( NgZone) private zone: NgZone,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) { }

  public toggleItem(index: number): void {
    console.log("✅ toggleItem 호출됨, index:", index);
    this.zone.run(() => {
      this.openedIndex = this.openedIndex === index ? null : index;
      console.log("📌 openedIndex 변경 후:", this.openedIndex);
      this.cdr.detectChanges();
    });
  }

  public selectQA(qa: any): void {
    console.log("🎯 QA 클릭됨:", qa);
    this.zone.run(() => {
      this.qaSelected.emit(qa);
      this.cdr.detectChanges();
    });
  }
}

export default ComponentChecklistComponent;